import { useState } from "react";
import { Stack, Paper, Button } from "@mui/material";
import { AlreadyCallDoneSearch } from "./already-call-done-search";
import { CONFIG } from "../../../../config";
import axios from "axios";
const API_HOST_CRM = CONFIG.modules["crm"].host;

export const PreviousActiveContent = ({ caseObject, onDeleteCase }) => { // Accept caseObject prop and onDeleteCase
    console.log("[PreviousActiveContent] caseObject:", caseObject);
    const [mode, setMode] = useState("default"); // "default" or "callDone"
    const [searchStatus, setSearchStatus] = useState("idle"); // "idle", "invalid", "searching", "found", "error"
    const [errorMessage, setErrorMessage] = useState("");

    const handleAlreadyCallDoneClick = async () => {
        setMode("callDone");
        const motherID = caseObject?.motherID; // Get motherID from caseObject
        const caseId = caseObject?._id; // Get caseId from caseObject

        if (!motherID || motherID.trim() === "" || !caseId || caseId.trim() === "") {
            setSearchStatus("invalid");
            setErrorMessage("Mother ID and Case ID are required.");
            return;
        }

        setSearchStatus("searching");
        setErrorMessage(""); // Clear any previous error messages
        try {
            const response = await axios.get(`${API_HOST_CRM}/cases/previous-call-done-case`, {
                params: {
                    motherID: motherID,
                    caseId: caseId
                }
            });

            if (response.data.success) {
                setSearchStatus("found");
            } else {
                setSearchStatus("error");
                setErrorMessage(response.data.message || "No previous call done case found.");
                console.log("No previous call done case found:", response.data.message);
            }
        } catch (error) {
            console.error("Error fetching previous call done case:", error);
            setSearchStatus("error");
            setErrorMessage(error.response?.data?.message || error.message || "An unexpected error occurred.");
        }
    };

    const handleConfirmDelete = () => {
        console.log("Delete allocation confirmed!");
        onDeleteCase(caseObject); // Call the onDeleteCase prop with the caseObject
        setMode("default");
        setSearchStatus("idle");
    };

    return (
        <Stack
            direction={"column"}
            spacing={1}
        >
            <Paper>
                <Stack direction={"row"} spacing={1} sx={{ p: 1 }}>
                    <Button variant="contained" onClick={handleAlreadyCallDoneClick}>
                        Already Call Done
                    </Button>
                </Stack>
            </Paper>
            {mode === "callDone" && (
                <AlreadyCallDoneSearch
                    motherID={caseObject?.motherID || ""} // Pass actual motherID or empty string
                    searchStatus={searchStatus}
                    errorMessage={errorMessage} // Pass errorMessage to the child component
                    onConfirmDelete={handleConfirmDelete}
                />
            )}
        </Stack>
    );
}